import type { IAxiosInstance } from "./types";

export class Features {
  static async get(api: IAxiosInstance, featureItem: string) {
    try {
      const res = await api.$post<boolean>("/monolithic/feature-viewed/check", {
        feature: featureItem,
      });
      return res;
    } catch (e: any) {
      return;
    }
  }

  static async set(api: IAxiosInstance, featureItem: string) {
    try {
      const res = await api.$put("/monolithic/feature-viewed/submit", {
        feature: featureItem,
      });
      return res;
    } catch (e: any) {
      return;
    }
  }
}
